import PageHeader from 'components/common/PageHeader';

export default function DefaultView({ children }) {
  return (
    <>
      <PageHeader />
      {children}
    </>
  );
}
